<!-- @format -->

<app-course-unit-info-modal-substitution-correspondences
  [allowEdit]="allowEdit"
  [showCrossStudySubstitutes]="showCrossStudySubstitutes"
  [validatablePlan]="validatablePlan"
  [plan]="plan"
  [courseUnit]="courseUnit"
  [versionChangeInProgress]="versionChangeInProgress"
  (selectSubstitutions)="this.selectSubstitutions.emit($event)"
  (removeSubstitutions)="this.removeSubstitutions.emit($event)"
  (openCourseUnitModal)="this.openCourseUnitModal.emit($event)">
</app-course-unit-info-modal-substitution-correspondences>
@if (courseUnit?.universityOrgIds.includes(currentUniversityOrgId)) {
  <app-course-unit-info-modal-prior-learning
    [courseUnit]="courseUnit"
    [plan]="plan"
    [openSubstitutionForm]="openSubstitutionForm"
    [openApplication]="openApplication"
    [studyRight]="studyRight">
  </app-course-unit-info-modal-prior-learning>
}
